<template>
  <ProfileCompletionContainer :result="result" :entity-id="agency.id" id-param="agencyId" />
</template>

<script setup lang="ts">
import { useProfileCompletion } from '@/composables/useProfileCompletion'
import type { AgencyData } from '@/gql/reviews'

import { agencyCompletionSections } from './agencyCompletionConfig'
import ProfileCompletionContainer from './ProfileCompletionContainer.vue'

const props = defineProps<{ agency: AgencyData }>()

const result = useProfileCompletion(() => props.agency, agencyCompletionSections)
</script>
